export default "__VITE_ASSET__D$_Rx_Go__"